import Tippy from "@tippyjs/react";
import cogoToast from "cogo-toast";
import moment from "moment";
import numeral from 'numeral';
import { useCallback, useMemo, useRef, useState } from "react";
import { Badge } from "react-bootstrap";
import { useQuery, useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import { PageTitle } from "../../../../../_metronic/layout/core";
import CardEx from "../../../../Components/Cards/CardEx";
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader";
import Semaphore from "../../../../Components/Semaphore/Semaphore";
import WrappedAgTable from "../../../../Components/Table/WrappedAgTable";
import { createCustomDateFilterParams } from "../../../../Components/Utils/Utils";
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { DeleteExcepcion, GetGarantiasToRecepcion } from "../../../../api/Api";
import PermissionsGate from "../../../../api/PermissionsGate";
import { SCOPES } from "../../../../config/permissions-map";
import { Unauthorized } from "../../../Global/unauthorized";
import { EXCEPCION_GARANTIA_ESTADO, EXCEPCION_GARANTIA_ESTADO_COLOR, EXCEPCION_GARANTIA_TIPO, GARANTIA_ESTADO, GARANTIA_ROL, GARANTIA_TIPO } from "../../../Utils/Constants";

export default function ListadoGarantiasExcepcion({ title }) {

  const {
    data: garantiasExcepcionList,
    isFetching: isFetchingGarantiasExcepcionList,
    refetch: refetchGetGarantiasExcepcion
  } = useQuery("getGarantiasExcepcion", () => GetGarantiasToRecepcion({
    "is_excepcion": null,
    "filter_by_only_tipos_garantia_definida": true,
    "filter_by_register_excepcion": user.role.id === GARANTIA_ROL.REVISOR_COMERCIAL,
    "filter_by_review_excepcion": user.role.id === GARANTIA_ROL.REVISOR_COBRANZA || user.role.id === GARANTIA_ROL.REVISOR_TESORERIA
  },));

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)
  const [isFinishDelete, setIsFinishDelete] = useState(false)

  const queryClient = useQueryClient();
  const user = useGetUser();

  const idGarantiaExcepcion = useRef(null);
  const nroCartaFianza = useRef(null);
  const nroOperacion = useRef(null);
  const nroContrato = useRef(null);

  const handleShowDeleteModal = useCallback((props) => {
    setShowDeleteModal(true);
    idGarantiaExcepcion.current = props.data.detalle_garantia.excepcion.id_garantia_excepcion;
    nroCartaFianza.current = props.data.detalle_garantia.nro_carta_fianza;
    nroOperacion.current = props.data.detalle_garantia.nro_operacion;
    nroContrato.current = props.data.garantia.nro_contrato;
  }, [])

  const header = useMemo(() => [
    {
      headerName: 'Id',
      field: 'detalle_garantia.id_garantia_detalle',
      pinned: 'left',
      width: 80,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Semáforos',
      field: 'semaforo_Revisores',
      pinned: 'left',
      filter: false,
      sortable: false,
      width: 120,
      cellRenderer: (props) => props.data ? (
        <>
          <div className="align-items-center d-flex h-100">
            <Semaphore
              caption='CO'
              size={'25px'}
              fontSize={'11px'}
              tooltipTitle={props.data.detalle_garantia.excepcion.nombre_estado_cobranza}
              lastUpdateDate={props.data.detalle_garantia.excepcion.fecha_revision_cobranza}
              lastUpdatedBy={props.data.detalle_garantia.excepcion.usuario_revisor_cobranza}
              tooltipDescription={""}
              color={EXCEPCION_GARANTIA_ESTADO_COLOR[props.data.detalle_garantia.excepcion.codigo_estado_cobranza]}>
            </Semaphore>
            {
              props.data.detalle_garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA
                || props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO ? (
                <Semaphore
                  caption='TE'
                  size={'25px'}
                  fontSize={'11px'}
                  tooltipTitle={props.data.detalle_garantia.excepcion.nombre_estado_tesoreria}
                  lastUpdateDate={props.data.detalle_garantia.excepcion.fecha_revision_tesoreria}
                  lastUpdatedBy={props.data.detalle_garantia.excepcion.usuario_revisor_tesoreria}
                  tooltipDescription={""}
                  color={EXCEPCION_GARANTIA_ESTADO_COLOR[props.data.detalle_garantia.excepcion.codigo_estado_tesoreria]}>
                </Semaphore>
              ) : null}

          </div>
        </>
      ) : <></>
    },
    {
      headerName: 'Acciones',
      width: 100,
      filter: false,
      pinned: 'left',
      sortable: false,
      cellRenderer: (props) => props.data ? (
        <div className="d-flex align-items-center h-100 justify-content-center">


          {[
            EXCEPCION_GARANTIA_ESTADO.INGRESADO.CODE,
            EXCEPCION_GARANTIA_ESTADO.PENDIENTE.CODE

          ].includes(props.data.detalle_garantia.excepcion.codigo_estado_excepcion) ? (

            user.role.id === GARANTIA_ROL.REVISOR_COBRANZA ? (
              <Tippy theme='light-border' content="Revisar Excepción">
                <Link to={`/garantias_revision_excepcion/${props.data.detalle_garantia.id_garantia_detalle}`} className="garantias-font d-flex align-items-center mx-2">
                  <i className="fi fi-rr-memo-circle-check color-icon-blue"></i>
                </Link>
              </Tippy>
            ) : (user.role.id === GARANTIA_ROL.REVISOR_TESORERIA &&
              props.data.detalle_garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA ? (
              <Tippy theme='light-border' content="Revisar Excepción">
                <Link to={`/garantias_revision_excepcion/${props.data.detalle_garantia.id_garantia_detalle}`} className="garantias-font d-flex align-items-center mx-2">
                  <i className="fi fi-rr-memo-circle-check color-icon-blue"></i>
                </Link>
              </Tippy>
            ) : null)
          ) : null}


          {EXCEPCION_GARANTIA_ESTADO.RECHAZADO.CODE === props.data.detalle_garantia.excepcion.codigo_estado_excepcion ||
            EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE === props.data.detalle_garantia.excepcion.codigo_estado_excepcion ||
            (user.role.id === GARANTIA_ROL.REVISOR_COMERCIAL && props.data.detalle_garantia.excepcion.id_garantia_excepcion) ? (
            <Tippy theme='light-border' content="Visualizar">
              <Link to={`/garantias_view_excepcion/${props.data.detalle_garantia.id_garantia_detalle}`} className="garantias-font d-flex align-items-center mx-2">
                <i className="fi fi-rr-binoculars color-icon-green"></i>
              </Link>
            </Tippy>
          ) : null}

          {(user.role.id === GARANTIA_ROL.REVISOR_COMERCIAL || user.role.id === GARANTIA_ROL.SUPER_ADMIN)
            && (
              [GARANTIA_ESTADO.INGRESADO, GARANTIA_ESTADO.PENDIENTE, GARANTIA_ESTADO.RECHAZADO].includes(props.data.detalle_garantia.estado.codigo)
              && ![EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE, EXCEPCION_GARANTIA_ESTADO.PENDIENTE.CODE].includes(props.data.detalle_garantia.excepcion.codigo_estado_excepcion)) ? (
            <>
              <Tippy theme='light-border' content={props.data.detalle_garantia.excepcion.id_garantia_excepcion ? `Actualizar Excepción` : `Registrar Excepción`}>
                <Link to={`/garantias_excepcion/${props.data.detalle_garantia.id_garantia_detalle}`} className="garantias-font d-flex align-items-center mx-2">
                  <i className="fi fi-rr-file-edit color-icon-blue"></i>
                </Link>
              </Tippy>
              {props.data.detalle_garantia.excepcion.id_garantia_excepcion ? (
                <Tippy theme='light-border' content="Eliminar">
                  <button className="btn btn-link garantias-font align-items-center d-flex h-100 justify-content-center mx-auto"
                    onClick={() => handleShowDeleteModal(props)}>
                    <i className="fi fi-rr-trash color-icon-red"></i>
                  </button>
                </Tippy>
              ) : null}

            </>

          ) : null}

        </div >

      ) : <></>
    },
    {
      headerName: 'Contrato',
      field: 'garantia.nro_contrato',
      width: 120,
      filter: 'agTextColumnFilter',
      pinned: 'left',

    },
    {
      headerName: 'Origen',
      field: 'detalle_garantia.origen.nombre',
      width: 110
    },
    {
      headerName: 'Estado',
      field: 'detalle_garantia.estado.nombre',
      width: 110,
      cellRenderer: (props) => {
        if (!props.data) {
          return <></>;
        }
        let element = '';
        if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.RECHAZADO) {
          element = <Badge bg="danger">{props.data.detalle_garantia.estado.nombre}</Badge>;
        } else if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.EN_REVISION) {
          element = <Badge bg="info">{props.data.detalle_garantia.estado.nombre}</Badge>;
        } else if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.APROBADO) {
          element = <Badge bg="success">{props.data.detalle_garantia.estado.nombre}</Badge>;
        } else {
          element = <Badge bg="secondary">{props.data.detalle_garantia.estado.nombre}</Badge>;
        }
        return <div className="align-items-center d-flex h-100">{element}</div>;
      }
    },
    {
      headerName: 'Tipo',
      field: 'detalle_garantia.tipo_garantia.nombre',
      width: 130
    },
    {
      headerName: "Excepcion de Garantía",
      stickyLabel: true,
      children: [
        {
          headerName: 'Excepción?',
          field: 'detalle_garantia.is_excepcion',
          filter: 'agSetColumnFilter',
          width: 120,
          valueGetter: (params) => {
            if (params.data.detalle_garantia.is_excepcion) {
              return "Con Excepción";
            } else {
              return "Sin Excepción";
            }
          },
          cellRenderer: (props) => {
            if (!props.data) {
              return <></>;
            }
            let element = '';
            if (!props.data.detalle_garantia.is_excepcion) {
              element = <Badge bg="secondary">Sin Excepción</Badge>;
            } else {
              if (props.data.detalle_garantia.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE) {
                element = <Badge bg="success">Con Excepción</Badge>;
              } else if (props.data.detalle_garantia.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.RECHAZADO.CODE) {
                element = <Badge bg="danger">Con Excepción</Badge>;
              } else {
                element = <Badge bg="warning">Con Excepción</Badge>;
              }
            }


            return <div className="align-items-center d-flex h-100">{element}</div>;
          }
        },
        {
          headerName: 'Tipo',
          field: 'detalle_garantia.excepcion.nombre_tipo_excepcion',
          width: 160,
        },
        {
          headerName: 'N° Factura',
          field: 'detalle_garantia.excepcion.numero_factura'
        },
        {
          headerName: 'Estado',
          field: 'detalle_garantia.excepcion.nombre_estado_excepcion',
          width: 120,
        },
        {
          headerName: 'Importe',
          field: 'detalle_garantia.excepcion.importe',
          width: 130,
          type: 'rightAligned',
          filter: 'agNumberColumnFilter',
          valueFormatter: function (params) {
            return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
          },
        },
        {
          headerName: 'Fec.Vecimiento',
          field: 'detalle_garantia.excepcion.fecha_vencimiento',
          width: 180,
          sortable: true,
          filter: 'agDateColumnFilter',
          filterParams: createCustomDateFilterParams,
          valueFormatter: function (params) {
            return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
          },
          cellClass: 'date'
        },
        {
          headerName: 'Sustento',
          field: 'detalle_garantia.excepcion.file_name_adjunto',
          width: 150,
          cellRenderer: (props) => {
            if (!props.data) {
              return <></>;
            }
            return <a href={props.data.detalle_garantia.excepcion.url_file_name_adjunto} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
              <span>{props.data.detalle_garantia.excepcion.file_name_adjunto}</span>
            </a>;
          }
        },
      ]
    },
    {
      headerName: 'Nro Carta Fianza',
      field: 'detalle_garantia.nro_carta_fianza',
      width: 150,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Nro Operación',
      field: 'detalle_garantia.nro_operacion',
      width: 150,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Contrato',
      field: 'garantia.nro_contrato',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'RUC',
      field: 'garantia.ruc',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Razon Social',
      field: 'garantia.razon_social',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Nombre Comercial',
      field: 'garantia.nombre_comercial',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Importe',
      field: 'detalle_garantia.importe',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Moneda',
      field: 'garantia.moneda.codigo',
      width: 90,
    },
    {
      headerName: 'Banco',
      field: 'detalle_garantia.banco.codigo',
      width: 100
    },
    {
      headerName: 'F.Venc. Carta Fianza',
      width: 180,
      field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
      filter: 'agDateColumnFilter',
      filterParams: createCustomDateFilterParams,
      valueFormatter: function (params) {
        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
      }
    },
    {
      headerName: 'F.Ingreso Recepción',
      width: 180,
      field: 'detalle_garantia.recepcion.fecha_ingreso_cuenta',
      filter: 'agDateColumnFilter',
      filterParams: createCustomDateFilterParams,
      valueFormatter: function (params) {
        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
      }
    }
  ], [handleShowDeleteModal, user]);

  const agGridLista = useMemo(() => ({
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 10,
      floatingFilter: true,
      enableRowGroup: true
    },
    columnDefs: header,
    rowData: isFetchingGarantiasExcepcionList ? undefined : garantiasExcepcionList?.data,
    pagination: true,
    paginationAutoPageSize: true,
    rowSelection: 'single',
    rowGroupPanelShow: 'always',
    domLayout: "normal",
    autoGroupColumnDef: {
      headerName: 'Grupo',
      filter: 'agGroupColumnFilter'
    }
  }), [
    header,
    garantiasExcepcionList?.data,
    isFetchingGarantiasExcepcionList
  ]);

  const handleConfirmDeleteModal = useCallback(() => {
    setIsLoadingDelete(true);
    const obj = {
      "id_garantia_excepcion": idGarantiaExcepcion.current,
      "updated_by": user.email
    }
    queryClient.fetchQuery('deleteExcepcion',
      () => DeleteExcepcion(obj)).then((result) => {
        if (result.success) {
          console.log('Se guardo');
          refetchGetGarantiasExcepcion();
          // setConfigurationSaveErrorMessage("");
        } else {
          // setConfigurationSaveErrorMessage("ERRORRR....");
        }

      }).catch((err) => {
        // setConfigurationSaveErrorMessage("ERRORRR....");
      }).finally(() => {
        setIsLoadingDelete(false)
        setIsFinishDelete(true);
      });
  }, [queryClient, refetchGetGarantiasExcepcion, user.email])

  const handleCloseDeleteModal = useCallback(() => {
    setIsLoadingDelete(false);
    setIsFinishDelete(false);
    idGarantiaExcepcion.current = null;
    nroCartaFianza.current = null;
    nroOperacion.current = null;
    nroContrato.current = null;
  }, [])

  const breadcrumbs = [
    { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Garantías", path: "", isActive: false, isSeparator: false },
  ];

  return (
    <>
      <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_EXCEPCION_GARANTIA]} >
        <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>
        <CardEx titleParent={title}
          title={"Listado de Garantías"}
          isAvailableMaximized={true}
          isAvailableBreadcrumbs={true}
          isAvailableRefetch={true}
          breadcrumbs={breadcrumbs}
          height={"100%"}
          onRefetch={async () => {
            await refetchGetGarantiasExcepcion();
            cogoToast.success('Registros actualizado satisfactoriamente!', {
              //hideAfter: 0,
              heading: 'Listado de Garantías',
              position: 'top-right'
            });
          }}>
          <WrappedAgTable
            titleExcel={"listado_de_garantias"}
            {...agGridLista} >
          </WrappedAgTable>
        </CardEx>
        <ConfirmWithLoader
          showModal={showDeleteModal}
          setShowModal={setShowDeleteModal}
          title={"Eliminar Excepción"}
          isLoading={isLoadingDelete}
          isFinish={isFinishDelete}
          textButton={"Eliminar"}
          textButtonCancel={"Cerrar"}
          onConfirm={handleConfirmDeleteModal}
          onClose={handleCloseDeleteModal}>
          {!isLoadingDelete && isFinishDelete ? (
            <>
              <div>La excepción ha sido eliminada exitosamente.</div>
            </>
          ) : (
            <div>Esta seguro de Eliminar la Excepción
              {nroContrato.current ? (
                <> del <b>Contrato {nroContrato.current}</b> ?</>
              ) : (
                <>
                </>
              )}
            </div>
          )}
        </ConfirmWithLoader>
      </PermissionsGate>
    </>
  )

}